import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { PurchaseConfirmationPageTranslation, type TranslatedValue } from "@swo/storefront";
import { SwarovskiButton } from "../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../../styles/breakpoints";
import cn from "classnames";
import { FONTS, fontSize } from "../../../styles/fonts";
import { T } from "../../../components/T";
import type { Translated } from "../../../domain/translations/translations";

export const PaymentStatusError: ReactTFC<{
  homepageLink: string;
  t: Translated<PurchaseConfirmationPageTranslation>;
  message: string | TranslatedValue;
  cardHolderInfo: string | undefined;
  retryPayment: undefined | { link: { pathname: string; search: string }; buttonLabel: TranslatedValue };
}> = props => {
  return (
    <>
      <div>
        <p css={lightStyles}>
          <T>{props.message}</T>
        </p>
        {props.cardHolderInfo && <p css={lightStyles}>{props.cardHolderInfo}</p>}
      </div>

      <div
        className={cn(props.retryPayment ? "two-buttons" : undefined)}
        css={css`
          display: flex;

          &.two-buttons {
            ${CSS_MQ.atMostXs} {
              flex-direction: column;
              align-items: stretch;
            }
          }

          justify-content: center;

          gap: 15px;
          ${CSS_MQ.atLeastMd} {
            gap: 40px;
          }
          align-items: baseline;

          margin-top: 50px;
          ${CSS_MQ.atLeastMd} {
            margin-top: 150px;
          }
        `}
      >
        {props.retryPayment ? (
          <>
            <SwarovskiButton variant={"outline"} as={"a"} isInternal link={props.homepageLink}>
              <T>{props.t("toHomePageLabel")}</T>
            </SwarovskiButton>

            <SwarovskiButton variant={"green"} as={"a"} link={props.retryPayment.link} isInternal={true}>
              <T>{props.retryPayment.buttonLabel}</T>
            </SwarovskiButton>
          </>
        ) : (
          <SwarovskiButton variant={"green"} as={"a"} isInternal link={props.homepageLink}>
            <T>{props.t("toHomePageLabel")}</T>
          </SwarovskiButton>
        )}
      </div>
    </>
  );
};

export const lightStyles = [
  fontSize.x25,
  FONTS.SwarovskiFutura300,
  css`
    display: block;
    text-align: center;
    margin-bottom: 12px;
  `,
];
